import intrack from '@/helpers/intrack'
import useSearchParams from './useSearchParams'
import getPlatform from '@/helpers/getPlatform'
import { SearchStateProps } from '@/redux/store/reducer/searchReducer'

interface intrackSearchViewArgs {
  roomsCount: number
  regionData: SearchStateProps['region_data']
}

const useSearchAnalytics = () => {
  const { params, queries } = useSearchParams()
  // When Search City | Province Page Viewed
  const intrackSearchView = ({
    roomsCount,
    regionData,
  }: intrackSearchViewArgs) => {
    if (!params.city && !params.province && !params.village) return
    const searchAttributes = {}

    searchAttributes['page_number'] = Number(queries.page) || 1
    searchAttributes['instant_reserve'] = !!Number(queries.instant)
    searchAttributes['platform'] = getPlatform()
    searchAttributes['rooms_count'] = +roomsCount

    if (params.city) {
      searchAttributes['city_name'] = params.city
      if (regionData?.province) {
        searchAttributes['province_name'] = regionData?.province
      }
    }
    if (params.province) {
      searchAttributes['province_name'] = params.province
    }
    if (params.village) {
      if (regionData?.province) {
        searchAttributes['province_name'] = regionData?.province
      }
      if (regionData?.city) {
        searchAttributes['city_name'] = regionData?.city
      }
      searchAttributes['village_name'] = params.village
    }
    if (queries.checkin) {
      searchAttributes['check_in'] = new Date(+queries.checkin * 1000) // format Eg: Sat Nov 26 2023 03:30:00 GMT+0330 (Iran Standard Time)
    }
    if (queries.checkout) {
      searchAttributes['check_out'] = new Date(+queries.checkout * 1000) // format Eg: Sat Nov 27 2023 03:30:00 GMT+0330 (Iran Standard Time)
    }
    if (queries.checkin && queries.checkout) {
      searchAttributes['number_of_nights'] = Math.round(
        Math.abs(
          (new Date(+queries.checkout * 1000) as any) -
            (new Date(+queries.checkin * 1000) as any),
        ) /
          (24 * 60 * 60 * 1000),
      )
    }
    if (Number(queries.guests)) {
      searchAttributes['number_of_guests'] = Number(queries.guests)
    }
    if (queries.min_price) {
      searchAttributes['min_price_range'] = +queries.min_price
    }
    if (queries.max_price) {
      searchAttributes['max_price_range'] = +queries.max_price
    }

    // ------------------ Type Attribute ------------------
    const houseTypes = {
      villa: 'ویلا',
      apartment: 'آپارتمان',
      cottage: 'کلبه',
      boomgardi: 'بوم گردی',
    }
    if (Object.keys(houseTypes).some(type => queries?.[type])) {
      searchAttributes['type'] = Object.keys(houseTypes)
        .filter(type => queries?.[type])
        .map(type => houseTypes?.[type])
        .join(', ')
    }
    // ------------------ Type Attribute End ------------------

    // ------------------ Features Attribute ------------------
    const houseFeatures = {
      twenty_four_hour: 'امکان پذیرش 24 ساعته',
      rule_ceremony: 'امکان برگزاری مراسم',
      rule_pets: 'امکان ورود حیوانات خانگی',
      ...((queries.outdoor_pool || queries.outdoor_pool || queries.pool) && {
        pool: 'استخر',
      }),
      wifi: 'اینترنت رایگان',
      jacuzzi: 'جکوزی',
      parking: 'پارکینگ',
    }
    if (Object.keys(houseFeatures).some(feature => queries?.[feature])) {
      searchAttributes['features'] = Object.keys(houseFeatures)
        .filter(feature => queries?.[feature])
        .map(feature => houseFeatures?.[feature])
        .join(', ')
    }
    // ------------------ Features Attribute End ------------------

    // ------------------ Landscape Attribute ------------------
    const houseLandscape = {
      forest: 'جنگلی',
      mountain: 'کوهستانی',
      desert: 'کویری',
      coastal: 'ساحلی',
      in_town: 'درون شهری',
    }
    if (Object.keys(houseLandscape).some(landscape => queries?.[landscape])) {
      searchAttributes['landscape'] = Object.keys(houseLandscape)
        .filter(landscape => queries?.[landscape])
        .map(landscape => houseLandscape?.[landscape])
        .join(', ')
    }
    // ------------------ Landscape Attribute End ------------------
    // check mid term
    if (queries?.mid_term === '1') {
      searchAttributes['is_midterm'] = true
    }
    intrack.track('search_view', searchAttributes)
  }
  return { intrackSearchView }
}

export default useSearchAnalytics
